import { render, staticRenderFns } from "./project-create.vue?vue&type=template&id=5918f17d&"
import script from "./project-create.vue?vue&type=script&lang=js&"
export * from "./project-create.vue?vue&type=script&lang=js&"
import style0 from "./project-create.vue?vue&type=style&index=0&id=5918f17d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports